// extracted by mini-css-extract-plugin
module.exports = {"campaignNotFound":"editor_campaignNotFound_1EFDo","elMain":"editor_elMain_3lXap","elAside":"editor_elAside_1b5I8","editorNav":"editor_editorNav_2wgK6"};